// RELY - Corporate Footer
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LEGAL_CONFIG } from '../../config/legal';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const links = [
    { to: '/terms', label: t('footer.terms', 'Términos y Condiciones') },
    { to: '/privacy', label: t('footer.privacy', 'Política de Privacidad') },
    { to: '/cookies', label: t('footer.cookies', 'Cookies') },
    { to: '/refund-policy', label: t('footer.refund', 'Reembolsos') },
    { to: '/blog', label: t('footer.blog', 'Blog') },
  ];

  return (
    <footer className="rounded-xl border-t border-neutral-200 bg-white dark:border-neutral-800 dark:bg-neutral-900">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          {/* Copyright */}
          <p className="text-sm text-neutral-500 dark:text-neutral-400">
            © {currentYear} {LEGAL_CONFIG.company.name}.{' '}
            {t('footer.rights', 'Todos los derechos reservados.')}
          </p>

          {/* Links */}
          <nav className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm text-neutral-500 transition-colors hover:text-secondary-500 dark:text-neutral-400 dark:hover:text-secondary-400"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
